module.exports = __webpack_public_path__ + "static/media/skrill.35fcb611.svg";